import { api } from '@ai/common/src/api/axios';
import type { PaginatedResponse } from '../../types/api';
import type { IUser, UserSelectItem } from '../../types/user';

class UsersService {
  private baseUrl = '/platform/api/v1/users';

  getListPaginated = async ({
    page,
    perPage,
    order,
    orderBy,
    search,
    searchRef,
    active,
  }: {
    page: number;
    perPage: number;
    order: 'asc' | 'desc' | undefined;
    orderBy: string | undefined;
    search: string | undefined;
    searchRef: string | undefined;
    active: boolean | undefined;
  }) => {
    const params = {
      page: page,
      per_page: perPage,
      order,
      order_by: orderBy,
      search,
      search_ref: searchRef,
      active,
    };

    return api.get<PaginatedResponse<IUser>>(`${this.baseUrl}/list_paginated`, {
      params,
    });
  };

  getAll = async () => api.get<UserSelectItem[]>(`${this.baseUrl}/all`);

  disable = async (userId: string) => api.put<IUser>(`${this.baseUrl}/${userId}/disable`);

  enable = async (userId: string) => api.put<IUser>(`${this.baseUrl}/${userId}/enable`);

  checkIfActive = async (userId: string) =>
    api.get<{ active: boolean }>(`${this.baseUrl}/${userId}/active`);
}

export const usersService = new UsersService();
